import { render } from "./HallsView.vue?vue&type=template&id=37818f32&ts=true"
import script from "./halls-view-component.ts?vue&type=script&lang=ts&external"
export * from "./halls-view-component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__